import investmentProposalAllClientData from './mocks/mockInvestmentProposalAllClient.json';

const discretionaryServiceMock = {
    getInvestmentProposalAllClient() {
        return investmentProposalAllClientData;
    },
    saveInvestmentProposalScreenCapture() {
        return Promise.resolve();
        // return Promise.reject();
    },
    sendInvestmentProposalScreenCaptureFailure() {
        return Promise.resolve();
    }
};

export default discretionaryServiceMock;
